import {IPrepExtensionsServerSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IUpdatePrepExtensionsServerSettingsParams {
  prepExtensionsServerSettings: IPrepExtensionsServerSettings;
}

export type IUpdatePrepExtensionsServerSettingsResult = IResult & IPrepExtensionsServerSettings;

export class UpdatePrepExtensionsServerSettingsRequest extends Request<IUpdatePrepExtensionsServerSettingsParams, IUpdatePrepExtensionsServerSettingsResult> {
  constructor(params: IUpdatePrepExtensionsServerSettingsParams) {
    super('updatePrepExtensionsServerSettings', params);
  }
}
